import React from 'react';
import { Paper } from '@material-ui/core';
import Box from '@mui/material/Box';
const BackgroundCard = (props: any) => {
  const { children } = props;
  return (
    <>
      <Box className='contentArea column-fluid'>{children}</Box>
    </>
  );
};

export default BackgroundCard;
